// extracted by mini-css-extract-plugin
export default {"oneColumn":"grid_oneColumn__d5zrA","twoColumns":"grid_twoColumns__HwA+w","threeColumns":"grid_threeColumns__ldn5D"};